module.exports = __webpack_public_path__ + "img/keypal-1.c31690a6.png";